import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "53",
  height: "53",
  viewBox: "0 0 53 53",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#clip0_54_503)" }, [
      _createElementVNode("path", { d: "M21.7742 39.7499C21.4714 39.7489 21.1721 39.6857 20.8947 39.5641C20.6174 39.4426 20.3681 39.2653 20.1621 39.0433L9.42965 27.6262C9.02846 27.1986 8.81354 26.6292 8.83217 26.0432C8.85081 25.4572 9.10147 24.9026 9.52903 24.5014C9.95658 24.1002 10.526 23.8853 11.112 23.9039C11.698 23.9225 12.2526 24.1732 12.6538 24.6008L21.7521 34.2953L40.3242 13.9787C40.5127 13.744 40.7472 13.5503 41.0132 13.4095C41.2793 13.2687 41.5713 13.1838 41.8714 13.16C42.1714 13.1362 42.4732 13.174 42.7581 13.271C43.043 13.3681 43.3051 13.5223 43.5283 13.7244C43.7514 13.9264 43.9309 14.1719 44.0557 14.4458C44.1805 14.7197 44.248 15.0163 44.254 15.3172C44.26 15.6182 44.2044 15.9172 44.0907 16.1959C43.9769 16.4746 43.8074 16.727 43.5926 16.9378L23.4084 39.0212C23.2044 39.2472 22.9559 39.4286 22.6785 39.554C22.4011 39.6794 22.1007 39.7461 21.7963 39.7499H21.7742Z" })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "clip0_54_503" }, [
        _createElementVNode("rect", {
          width: "53",
          height: "53"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }